<div class="media profile-media">
  <img alt="" class="b-r-10" src="assets/images/dashboard/profile.png">
  <div class="media-body"><span>{{userEmail}}</span>
    <p class="mb-0 font-roboto">user <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li (click)="showPasswordModal()"><app-feather-icons [icon]="'password'"></app-feather-icons><span>Change password</span></li>
  <!-- <li><a href="/user/profile"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li>
  <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
  <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li>
  <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li> -->
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span></li>
</ul>
<password-change  (passwordChangeEvent)="passwordChangeEventHandler($event)"  [display]="showPasswordEdit"></password-change>
